export const EVEN_DISTRIBUTED_COL_WIDTHS: { [key: number]: number } = {
	1: 100,
	2: 50,
	3: 33.33,
	4: 25,
	5: 20,
};
